import "bijou";
import "bijou/smart_form/pickadate";
import "analytics/event_definitions";
import { startNamedInteraction, stepActionOf } from "util/newRelicInteraction";

$(() => {
  $.bijou.init();
  $.ajaxSetup({
    error(jqXHR, textStatus, errorThrown) {
      if (typeof newrelic !== "undefined" && textStatus !== "abort" && jqXHR.status !== 0) {
        const method = this.type || "REQUEST";
        const url = this.url || jqXHR?.responseURL || "unknown";
        const err = new Error(
          `AJAX ${method} ${url} failed: ${jqXHR.status} ${errorThrown}`,
        );
        newrelic.noticeError(err, {
          ajaxUrl: url,
          ajaxMethod: method,
          httpStatus: jqXHR.status,
          textStatus: textStatus,
          errorThrown: String(errorThrown),
        });
      }
    },
  });
  $(document).ajaxSend((_event, jqXHR, settings) => {
    const action = stepActionOf(settings.url);
    if (action) {
      jqXHR.always(startNamedInteraction(action));
    }
  });
});
